<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO: {{ formData.userPaymentRequestNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.userPaymentRequestStatus === 'Y'
              ? 'success'
              : formData.userPaymentRequestStatus === 'S'
              ? 'warning'
              : formData.userPaymentRequestStatus === 'D' ||
                formData.userPaymentRequestStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_userPaymentRequestStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.salesPersonName"
              :placeholder="
                $l('tips_select_salesPersonCode') || '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDatePicker"
              :placeholder="$l('tips_select_requestDate') || '请选择申请日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_userPaymentRequestType') || '请款类型'"
            prop="userPaymentRequestType"
          >
            <dict-select
              v-model="formData.userPaymentRequestType"
              url="/master/common/dict/biz"
              :body="userPaymentRequestTypeParams"
              :placeholder="
                $l('tips_select_userPaymentRequestType') || '请选择请款类型'
              "
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expensePayer') || '付款公司'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :body="expensePayerParams"
              :selectedLabel.sync="formData.expensePayerName"
              :placeholder="$l('tips_select_expensePayer') || '请选择付款公司'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_payeeType') || '收款方'"
            prop="payeeType"
          >
            <dict-select
              v-model="formData.payeeType"
              url="/master/common/dict/biz"
              :body="payeeTypeParams"
              :placeholder="$l('tips_select_payeeType') || '请选择收款方'"
              filterable
              size="mini"
              @change="payeeTypeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.payeeType === 'S'">
          <el-form-item
            :label="$l('form_label_payeeScmCode') || '收款供应商'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="
                $l('tips_select_payeeScmCode') || '请选择收款供应商'
              "
              size="mini"
              clearable
              filterable
              @change="payeeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.payeeType === 'C'">
          <el-form-item
            :label="$l('form_label_payeeCustCode') || '收款客户'"
            prop="payeeCustCode"
          >
            <dict-select
              v-model="formData.payeeCustCode"
              url="/digitalCenter/common/dict/customer"
              :placeholder="$l('tips_select_payeeCustCode') || '请选择收款客户'"
              size="mini"
              clearable
              filterable
              @change="payeeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_payeeScmBankName') || '收款方开户银行'"
            prop="bankName"
          >
            <el-input
              v-model="formData.bankName"
              readonly
              :placeholder="
                $l('tips_select_payee_bank_name') || '请选择收款方开户银行'
              "
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountName') || '收款方账户名称'
            "
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payeeScmBankAccountNo') || '收款方银行账号'"
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountType') || '收款方银行账户性质'
            "
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountKind') || '收款方银行账号类别'
            "
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('tips_select_currencyUnit') || '请选择货币单位'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              :placeholder="$l('tips_select_paymentMethod') || '请选择付款方式'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '发票费用类型'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('tips_input_remark') || '请输入发票费用类型...'"
              maxlength="50"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '情况说明'"
            prop="description"
          >
            <el-input
              v-model="formData.description"
              :placeholder="$l('tips_input_description') || '请输入情况说明...'"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_notes') || '备注'">
            <el-input
              v-model="formData.notes"
              :placeholder="$l('tips_input_Notes') || '请输入备注...'"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :userPaymentRequestCode="userPaymentRequestCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
          :salesPersonCode="formData.salesPersonCode"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :userPaymentRequestCode="userPaymentRequestCode"
        />
      </el-row>
    </el-form>
    <ChooseBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payeeScmBank') || '选择收款方银行信息'"
      @confirm="updateBanInfo"
      :selectApi="selectBankApi"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import ChooseBank from '../choose-bank'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable, ChooseBank },
  mixins: [EditLoading],
  props: {
    userPaymentRequestCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      chooseScmBankVisible: false,
      userPaymentRequestTypeParams: { dictType: 'userPaymentRequestType' },
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      formData: {
        userPaymentRequestType: '4',
        salesPersonCode: '',
        salesPersonName: '',
        payeeType: 'C',
        payeeScmCode: '',
        payeeCustCode: '',
        currencyAmount: 0,
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        v_bankAccountType: '',
        bankAccountKind: '',
        v_bankAccountKind: '',
        remark: '',
        description: '',
        notes: '',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('tips_select_salesPersonCode') || '请选择业务人员',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('tips_select_requestDate') || '请选择申请日期',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('tips_select_expensePayer') || '请选择付款公司',
            trigger: 'change',
          },
        ],
        payeeType: [
          {
            required: true,
            message: this.$l('tips_select_payeeCustCode') || '请选择收款客户',
            trigger: 'change',
          },
        ],
        userPaymentRequestType: [
          {
            required: true,
            message:
              this.$l('tips_select_userPaymentRequestType') || '请选择请款类型',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('tips_select_currencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
        paymentMethod: [
          {
            required: true,
            message: this.$l('tips_select_paymentMethod') || '请选择付款方式',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message:
              this.$l('tips_select_payee_bank_name') || '请选择收款方开户银行',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('tips_input_remark') || '请输入发票费用类型...',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            message: this.$l('tips_input_description') || '请输入情况说明...',
            trigger: 'change',
          },
        ],
      },
      selectBankApi: () => [],
      salesPersonInfo: {},
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.userPaymentRequestCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.salesPersonCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        this.salesPersonInfo = res.body || {}
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.userPaymentRequestCode) return
      this.$api
        .userPaymentRequestDetailApi({
          userPaymentRequestCode: this.userPaymentRequestCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || listItem.length < 1) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      for (let i = 0; i < listItem.length; i++) {
        if (
          listItem[i].substituteInvoice === '0' &&
          !listItem[i].originalExpenseType
        ) {
          this.$message.error(
            this.$l('tips_add_original_cost') || '请添加原始费用项目'
          )
          return
        }
      }
      const listDoc = this.$refs.docTable.getTableData() || []
      const invoiceDocList = listDoc.filter((e) => e.payDocFileType == 'A')
      let saveFlag = true
      if (!invoiceDocList || !invoiceDocList.length) {
        saveFlag = false
        await this.$confirm(
          this.$l('tips_no_save_invoice') || '您尚未上传发票，是否保存？',
          this.$l('label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('btn_cancel') || '取消',
            type: 'warning',
          }
        ).then(async () => {
          saveFlag = true
        })
      }
      if (saveFlag) {
        this.loadingOpen()
        this.$api
          .userPaymentRequestSaveApi({ ...this.formData, listItem, listDoc })
          .then(async () => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_save_ok') || '保存成功！',
              type: 'success',
            })
            if (!this.userPaymentRequestCode) {
              this.closeCurPage()
            } else {
              this.reload()
            }
          })
          .catch(() => {
            this.loadingClose()
          })
      }
    },
    payeeTypeChange() {
      this.formData.payeeScmCode = ''
      this.formData.payeeCustCode = ''
      this.updateBanInfo({})
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async payeeChange(code) {
      const { payeeType } = this.formData
      const listBank =
        payeeType == 'C'
          ? await this.getCustData({ custCode: code })
          : await this.getScmData({ scmCode: code })
      const bankData = !listBank || listBank.length > 1 ? {} : listBank[0] || {}
      this.updateBanInfo(bankData)
    },
    async getCustData(form) {
      return await this.$api
        .masterCustomerBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async getScmData(form) {
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    openChoosePayScmBank() {
      const { payeeScmCode, payeeCustCode } = this.formData
      if (!payeeScmCode && !payeeCustCode) {
        this.$message({
          message: this.$l('tips_save_first') || '请先选择收款客户或收款供应商',
          type: 'warning',
        })
        return
      }

      const { payeeType } = this.formData
      if (payeeType === 'C') {
        this.selectBankApi = (form) =>
          this.getCustData({ ...form, custCode: this.formData.payeeCustCode })
      } else {
        this.selectBankApi = (form) =>
          this.getScmData({ ...form, scmCode: this.formData.payeeScmCode })
      }

      this.chooseScmBankVisible = true
    },
    updateBanInfo(e) {
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e || {}
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
